import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getDealsForV2Customer = (treeId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_DEALS_FOR_V2_CUSTOMER' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/discovery-tree/${treeId}/deals`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_DEALS_FOR_V2_CUSTOMER_DONE',
              payload: {
                bots: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_DEALS_FOR_V2_CUSTOMER_FAILED',
              payload: `Failed to get deals for v2 customer`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_DEALS_FOR_V2_CUSTOMER_FAILED',
            payload: `Failed to get deals for v2 customer`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_DEALS_FOR_V2_CUSTOMER_FAILED',
        payload: `Failed to get deals for v2 customer`,
      });
    }
  };
};

export default getDealsForV2Customer;
